"use client";

import { useEffect } from "react";
import { captureUtmData } from "@/utils/common/utm";

export default function UtmCapture() {
  useEffect(() => {
    captureUtmData();
  }, []);

  return null;
}
